/* eslint-disable import/prefer-default-export */
export function setConfirmationKeyIfExists(
  { dispatch, setConfirmationKey, confirmationKey }
) {
  if (confirmationKey) {
    dispatch(setConfirmationKey(confirmationKey));
  }
}

export function setImpersonationKeyIfExists(
  { dispatch, setImpersonationKey, impersonationKey }
) {
  if (impersonationKey) {
    dispatch(setImpersonationKey(impersonationKey));
  }
}
